var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaborCostRate = function SvgLaborCostRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0062FF",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13.02 14.778a3.13 3.13 0 0 1-3.138-3.125 3.13 3.13 0 0 1 3.138-3.126c1.733 0 3.137 1.4 3.137 3.126a3.13 3.13 0 0 1-3.137 3.125m0-1.25c1.04 0 1.883-.84 1.883-1.875a1.88 1.88 0 0 0-1.883-1.876c-1.04 0-1.882.84-1.882 1.876 0 1.035.842 1.875 1.882 1.875m0 7.501c-2.773 0-5.02-.69-5.02-2.446s2.247-3.18 5.02-3.18 5.02 1.424 5.02 3.18-2.248 2.446-5.02 2.446m0-1.25c2.476 0 3.765-.556 3.765-1.196 0-.917-1.6-1.93-3.765-1.93s-3.765 1.013-3.765 1.93c0 .64 1.289 1.196 3.765 1.196m-1.378 3.265a.621.621 0 1 1 .588-1.094 6.835 6.835 0 1 0 4.623-12.72.621.621 0 0 1 .252-1.217 8.077 8.077 0 1 1-5.463 15.031m8.552-5.614a.621.621 0 1 1-1.184-.376q.173-.546.174-1.132c0-1.36-.733-2.59-1.895-3.247a.621.621 0 0 1 .611-1.082 4.97 4.97 0 0 1 2.294 5.837"
  }))));
};
export default SvgLaborCostRate;